// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GuardrailPipelineSchema = z.enum(['ATTACK','DISCOVERY'] as const);

export type GuardrailPipelineType = `${z.infer<typeof GuardrailPipelineSchema>}`

export default GuardrailPipelineSchema;
